import React from 'react';
import { prepareHeadline } from './tree';
import { Heat } from './heat';
import { chunkArray } from '../../Utils/array';

const AdditionalRound = ({
  name,
  heats,
  activeHeat,
  setHeat,
  disabled,
  isActiveRound,
  config
}) => {
  const cols = chunkArray([...heats], 2);

  return (
    <div className={`additionalRound${disabled ? ' disabled' : ''}`}>
      <div className="head">
        <h4 className={`h4${isActiveRound ? ' textActive' : ''}`}>
          {prepareHeadline(name)}
        </h4>
      </div>
      <div className="additionalRound_cols">
        {cols &&
          cols.map((col, i) => (
            <div
              className="additionalRound_col"
              key={`additionalRound_col-${i}`}
            >
              {col.map(heat => (
                <Heat
                  heat={heat}
                  activeHeat={activeHeat}
                  key={`heat-${heat.id}`}
                  setHeat={setHeat}
                  config={config}
                />
              ))}
            </div>
          ))}
      </div>
    </div>
  );
};

export { AdditionalRound };
